module.exports = __webpack_public_path__ + "img/jinyongsheng.3edf6a60.jpg";